import React from "react";

import { useRouter } from "../../../common/hooks/useRouter";

import { MessagePageLayout } from "../";

import { HOME_PATH } from "../../constants/routes.consts";

import notFoundImage from "../../../../assets/images/mercurio_error_404.svg";
import errorImage from "../../../../assets/images/mercurio_error_505.svg";

const DEFAULT_PROPS = {
  error: {},
};

export const ErrorMessagesPage = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };

  const status = attrs.error?.response?.status || 400;

  const router = useRouter();

  const handleGoToHome = () => {
    router.push(HOME_PATH);
  };

  switch (status) {
    case 404:
      return (
        <MessagePageLayout
          confirmButtonProps={{
            children: "Ir al inicio",
            onClick: handleGoToHome,
          }}
          imageProps={{ src: notFoundImage }}
          title="Esta página no existe o fue eliminada"
          text="Revisa el enlace o intenta con otro. Si buscas un ítem específico, utiliza los filtros de cada sección."
        />
      );
    default:
      return (
        <MessagePageLayout
          imageProps={{ src: errorImage }}
          text="Por un error del sistema, no logramos mostrarte la información. Intenta de nuevo más tarde."
          title="No logramos cargar esta página"
        />
      );
  }
};
